export const utmSource = () => {
  if (typeof window === 'undefined') {
    return null
  }
  const thisURL = new URL(window.location.href)
  return thisURL.searchParams.get('utm-source')
}
